import {FC} from 'react';

import {Box, Dialog, DialogContent, DialogTitle, IconButton, styled, Typography} from '@mui/material';

import {CloseIcon} from 'assets/icons/closeIcon';
import Button from 'components/button/Button';

export type BasketPopupDialogProps = {
  open: boolean;
  onGoBack: () => void;
  title: string;
  children: React.ReactNode;
  confrmButtonText: string;
  modalInfo: string;
  onConfirmAndContinue: () => void;
  loading: boolean;
};

export const BasketAcknowledgementDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: '448px'
  }
}));

export const BasketAcknowledgementTitle = styled(DialogTitle)(() => ({
  padding: '16px 16px 12px 16px'
}));

export const ModalInfoText = styled(Typography)(() => ({
  margin: '0px 16px 0px 16px'
}));

export const BasketAcknowledgementContent = styled(DialogContent)(() => ({
  maxHeight: '80vh',
  padding: '0px 20px 0px 20px'
}));

export const BasketAcknowledgementButton = styled(Button)(() => ({
  margin: '0px 16px 16px 16px'
}));

export const DialogFooter = styled(Box)(({theme}) => ({
  '&': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    margin: theme.spacing(2, 0, 0, 0),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.fontSize - 4,
      gap: theme.spacing(0)
    }
  }
}));

export const BasketPopUpDialog: FC<BasketPopupDialogProps> = (props) => {
  const {open, title, onGoBack, children, confrmButtonText: btnText, modalInfo, onConfirmAndContinue, loading} = props;

  return (
    <BasketAcknowledgementDialog open={open} onClose={onGoBack}>
      <BasketAcknowledgementTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography fontWeight="bold" fontSize={20}>
            {title}
          </Typography>
          <IconButton size="small" color="inherit" onClick={onGoBack} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </BasketAcknowledgementTitle>
      <ModalInfoText>{modalInfo}</ModalInfoText>
      <BasketAcknowledgementContent>{children}</BasketAcknowledgementContent>
      <DialogFooter>
        <BasketAcknowledgementButton
          disabled={loading}
          onClick={() => onConfirmAndContinue()}
          fullWidth
          type="button"
          color="primary"
          variant="contained"
          shape="rounded"
        >
          {btnText}
        </BasketAcknowledgementButton>
      </DialogFooter>
    </BasketAcknowledgementDialog>
  );
};

export default BasketPopUpDialog;
